import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface ReadWidgetsCriteria {
    dashboardId: string;
}

class ReadWidgetsCriteriaImpl implements ReadWidgetsCriteria {
    constructor(readonly dashboardId: string) {}
}

export class ReadWidgetsCriteriaBuilder {
    private dashboardId: Option<string> = none;

    static create = (): ReadWidgetsCriteriaBuilder => new ReadWidgetsCriteriaBuilder();

    withDashboardId = (dashboardId: string): ReadWidgetsCriteriaBuilder => {
        this.dashboardId = some(dashboardId);
        return this;
    };

    build = (): ReadWidgetsCriteria => {
        if (isNone(this.dashboardId)) {
            throw new ReferenceError('Undefined prop');
        }

        return new ReadWidgetsCriteriaImpl(this.dashboardId.value);
    };
}
